<div class="cell-array">
  <div class="first-item">{{ data.length > 0 ? data[0] : textOnEmpty }}</div>
  <div class="second-item" *ngIf="data.length > 1" [matTooltip]="toolTipText" matTooltipClass="tooltip-container">
    +{{ data.length - 1 }}
  </div>
</div>
